import { useEffect, useState } from 'react'
import { changesToTurtle } from '../helpers'
import { Loading } from 'Components'
import AceEditor from 'react-ace'

Changelist = ({ source, target, commitId, diff }) ->

  [turtle, setTurtle] = useState('')
  [activeNode, setActiveNode] = useState(undefined)
  [loading, setLoading] = useState(true)

  useEffect( ->
    ( ->
      if commitId?
        { squashedWrites } = await Weaver.getInstance().getCoreManager().gitShow(commitId)
      else if diff?
        squashedWrites = diff.squashedWrites
      else
        { squashedWrites } = await Weaver.Branch.diffBranches(new Weaver.Branch(target), new Weaver.Branch(source))
      setTurtle(changesToTurtle(squashedWrites))
      setActiveNode(undefined)
      setLoading(false)
      undefined
    )()
    undefined
  , [source, target])

  if loading
    <Loading />
  else
    <AceEditor
      setOptions={{ readOnly: true }}
      mode="turtle"
      theme="github"
      value={turtle}
      width="100%"
    />

export default Changelist
